import {defineStore} from "pinia";

interface MainStore {
    domain: string,
    loading: boolean,
    complete: boolean,
}

export const useMainStore = defineStore('main', {
    state: (): MainStore => ({
        domain: window.location.origin,
        loading: false,
        complete: false,
    }),

    actions: {
        //
    }
})
